import { LanderCookie } from "../commons/Constants";
import { LanderConfig } from "../types/LanderConfig";
import { getExpiryPartnerConfig } from "../commons/LanderConfig";
import { getCookie } from "../commons/HelperFunctions";

interface RsocBuildResult {
  url: string | null;
  error: boolean;
}

/**
 * Build RSOC redirect URL from landerConfig
 * Returns { url, error } - does not fire events (caller handles that)
 */
export function buildRsocRedirectUrl(
  landerConfig: LanderConfig
): RsocBuildResult {
  try {
    let rsocUrl: URL;
    if (landerConfig.rsoc.url) {
      rsocUrl = new URL(landerConfig.rsoc.url);
    } else {
      rsocUrl = new URL(landerConfig.rsoc.path, "https://www.searchhounds.com");
    }

    // Query params that will be used in searchhounds
    rsocUrl.searchParams.set("psystem", landerConfig.system);
    rsocUrl.searchParams.set("domain", window.location.hostname);

    const expiryPortfolioId = getExpiryPartnerConfig().portfolioId || "";
    if (expiryPortfolioId) rsocUrl.searchParams.set("pid", expiryPortfolioId);

    // Preserve original referrer - check query param first, then document.referrer
    // The oref query parameter may be set by JS redirect from parking-lander-tls-terminator
    // https://github.com/gdcorp-domains/parking-lander-tls-terminator
    const urlParams = new URLSearchParams(window.location.search);
    const orefParam = urlParams.get("oref");
    const originalReferrer = orefParam || document.referrer;
    if (originalReferrer) {
      rsocUrl.searchParams.set("oref", originalReferrer);
    }

    const trafficTarget = getCookie(LanderCookie.TRAFFIC_TARGET);
    if (trafficTarget) {
      rsocUrl.searchParams.set("trafficTarget", trafficTarget);
    }

    return { url: rsocUrl.toString(), error: false };
  } catch {
    return { url: null, error: true };
  }
}
